// Generated from fixed build58. Run scripts/generate-badge-reference.cjs.
export const badgeIconOffsetByKey = {
  goal_three_months: { y: -0.4 },
  goal_week_streak_4: { y: -0.4 },
  goal_six_months: { y: -0.35 },
  goal_week_streak_12: { y: -0.4 },
  reviews_25: { y: -0.3 },
  genres_10: { x: 0.2, y: -0.15 },
  members_explored_10: { x: -0.85, y: -0.2 },
  members_explored_30: { x: -0.85, y: -0.2 },
  discoveries_25: { x: -0.65, y: -0.65 },
  shares_first: { x: 0.4, y: -0.15 },
  shares_3: { x: 0.45, y: 0.15 },
  community_days_5: { x: 0.2, y: -0.35 },
  community_days_3: { x: 0.2, y: -0.35 },
  following_5: { x: -0.75, y: -0.2 },
  following_20: { x: -0.85, y: -0.2 },
  reactions_10: { y: -0.3 },
  community_days_30: { x: 0.2, y: -0.35 },
  reactions_50: { x: -0.85, y: -0.2 },
  reactions_25: { x: -0.85, y: -0.2 },
  streak_3: { y: -0.55 },
  streak_7: { y: -0.4 },
  streak_14: { y: -0.2 },
  streak_30: { y: -0.4 },
  active_weeks_4: { y: -0.4 },
  active_weeks_12: { y: -0.4 },
};
